/* eslint-disable */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import JsonExcel from "vue-json-excel";

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import VueBarcode from 'vue-barcode'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/sweet-alerts'

// Axios Mock Adapter
import '@/@fake-db/db'


Vue.component("downloadExcel", JsonExcel);

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core stylesZ
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import assets styles
require('@/assets/css/style.css')

// currency
import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

Vue.component('barcode', VueBarcode)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
